<div class="lead-information-form-container" *ngIf="modelConfiguration">

  <mat-card>

    <mat-card-content>

      <div class="ct-model-container">
        <ct-model [configuration]="modelConfiguration"></ct-model>
      </div>

      <mat-card-actions align="end" *ngIf="modelConfiguration?.form">
        <ct-button [configuration]="submitButton"></ct-button>
      </mat-card-actions>

    </mat-card-content>

  </mat-card>

</div>
